import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

import 'rxjs/add/operator/retry';
import { Tools } from '../tools';
import { Observable } from 'rxjs/Observable';

export enum MethodType {
  GET,
  POST,
  PUT,
  DELETE,
}

/**
 * Service that handles the requests to the API:
 */
@Injectable()
export class BackendService {
  /**
   * Constructor
   * @param {HttpClient} http HttpClient
   */
  constructor(private http: HttpClient) {}

  private serverRequest<T>(method: MethodType, serviceUrl: string, body = {}, retries: number = 0): Promise<T> {
    let request: Observable<T>;

    switch (method) {
      case MethodType.GET:
        request = this.http
          .get<T>(serviceUrl, {
            params: body,
          })
          .retry(+retries);
        break;
      case MethodType.POST:
        request = this.http.post<T>(serviceUrl, body).retry(+retries);
        break;
      case MethodType.PUT:
        request = this.http.put<T>(serviceUrl, body).retry(+retries);
        break;
      case MethodType.DELETE:
        request = this.http
          .delete<T>(serviceUrl, {
            params: body,
          })
          .retry(+retries);
        break;
      default:
        break;
    }

    return new Promise((resolve, reject) => {
      request.subscribe(
        (response: T) => {
          resolve(response);
        },
        (err: HttpErrorResponse) => {
          reject(Tools.checkError(err));
        }
      );
    });
  }

  /**
   * Get method
   * @param serviceUrl URL
   * @param {object} params Params
   * @param {number} retries Number of retries
   * @returns {Promise<T>} Response as promise
   */
  get<T>(serviceUrl: string, params = {}, retries: number = 0): Promise<T> {
    // The route interceptor will replace the '$' by the backend url
    return this.serverRequest<T>(MethodType.GET, '$' + serviceUrl, params, retries);
  }

  /**
   * Post method
   * @param serviceUrl URL
   * @param {object} body Body with params
   * @param {number} retries Number of retries
   * @returns {Promise<T>} Response as promise
   */
  post<T>(serviceUrl: string, body = {}, retries: number = 0): Promise<T> {
    // The route interceptor will replace the '$' by the backend url
    return this.serverRequest<T>(MethodType.POST, '$' + serviceUrl, body, retries);
  }

  /**
   * Put method
   * @param serviceUrl URL
   * @param {object} body Body with params
   * @param {number} retries Number of retries
   * @returns {Promise<T>} Response as promise
   */
  put<T>(serviceUrl: string, body = {}, retries: number = 0): Promise<T> {
    // The route interceptor will replace the '$' by the backend url
    return this.serverRequest<T>(MethodType.PUT, '$' + serviceUrl, body, retries);
  }

  /**
   * Delete method
   * @param serviceUrl URL
   * @param {object} params Params
   * @param {number} retries Number of retries
   * @returns {Promise<T>} Response as promise
   */
  delete_<T>(serviceUrl: string, params = {}, retries: number = 0): Promise<T> {
    // The route interceptor will replace the '$' by the backend url
    return this.serverRequest<T>(MethodType.DELETE, '$' + serviceUrl, params, retries);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/shared/services/backend.service.ts